import { Nav, Navbar } from "react-bootstrap";
import { BsPower } from "react-icons/bs";
import ringerSfx from '../sounds/ringer.wav';
import SockJsClient from 'react-stomp';
import React, { useContext, useState } from "react";
import { BASE_URL_WS, LOGOUT } from "../api/Routes";
import { toast } from "react-toastify";
import moment from "moment";
import ReactAudioPlayer from "react-audio-player";
import { AiOutlineVideoCamera } from "react-icons/ai";
import Post from "../api/Post";
import { isDoctor } from "../utils/isDoctor";
import { authContext } from "../context/AuthContext";

export default function Notifications({auth, setAuthData}) {
    const [muted, setMuted] = useState(true)
    
    const logout = e =>{
        let url = `${LOGOUT}?email=${auth.data.username}`
        Post({url: url, data: {}, access_token: auth.data.access_token, header: true})
        .then(response=>{
            //console.log(response)            
        })
        .catch(error=>{
            console.log('error no se puede desloguear')
        })
        setAuthData(null);       

    }

    const handleCloseAlert = () =>{
        setMuted(true)
    }

    const  handleMessage = (message) =>{
        //console.log(message)
        if(!message.typeAppointment){
            toast.error(message.message, {autoClose: 8000, onClose: handleCloseAlert})
            setMuted(false)
        }else{
            if(message.typeAppointment==='OnDemand'){
                toast.warning(
                    <Msg message={message}/>, 
                    {
                        autoClose: false,
                        onClose: handleCloseAlert
                    })
                setMuted(false)
            }else{
                if(isDoctor(auth.data.role)){
                    toast.info(
                        <Msg message={message}/>, 
                        {
                            autoClose: false,
                            onClose: handleCloseAlert
                        })    
                }else{
                    toast.info(
                        <Msg message={message}/>, 
                        {
                            autoClose: false,
                            onClose: handleCloseAlert
                        })
                }
                setMuted(false)
            }
        }
    }

    return (
        <Navbar bg="wite" expand="lg" className="shadow-sm h80px z-index-3">             
            <Nav className="ml-auto"> 
                <Navbar.Text className="mr-4 name-user d-none d-md-block">
                    {auth.data.fullname}
                </Navbar.Text>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                        <span className="pr-3 position-relative">
                            <div className="d-none">
                                <ReactAudioPlayer
                                    src={ringerSfx}
                                    autoPlay={true}
                                    loop={true}
                                    controls={false}
                                    muted={muted}
                                />
                            </div>
                            <SockJsClient 
                                url={`${BASE_URL_WS}/ws`} 
                                topics={[`/user/${auth.data.username}/queue/notify`]}
                                onMessage={(message) => handleMessage(message)} 
                            />
                        </span>
                    </li>
                    <li className="list-inline-item"><span className="nav-link btn-off" onClick={logout}><BsPower className="btn-off-ico"/></span></li>
                </ul>                             
            </Nav>             
        </Navbar>
    )
}

function Msg({ message }){
    const {auth} = useContext(authContext)
    return (
        isDoctor(auth.data.role) ?
        <div>
            <label className="d-block m-0"><AiOutlineVideoCamera className="d-block font-size-2rem"  /> Dr(a) {message?.doctorName}, tiene una nueva cita agendada para el día</label>
            {message && <label className="d-block m-0">{moment(message.hourStart, "DD/MM/YYYY").format("DD/MM/YYYY")} a las {moment(message.hourStart, "DD/MM/YYYY HH:mm").format("HH:mm")}</label>}
        </div> :
        <div>
            <label className="d-block m-0"><AiOutlineVideoCamera className="d-block font-size-2rem"  /> Nueva solicitud de autorización</label>
            {message && <label className="d-block m-0">{message.message}</label>}
        </div>
        
    )    
}
